import React from "react";
import Typography from "@material-ui/core/Typography";

function FeatureText(props) {
  const { icon, title, subtitle } = props;

  return (
    <>
      {icon && (
        <div
          aria-hidden="true"
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 60,
            height: 60,
            fontSize: 30,
            lineHeight: 1,
            borderRadius: 18,
            marginBottom: "1.4rem",
            background:
              "linear-gradient(135deg, rgba(255,77,109,0.28), rgba(124,77,255,0.28))",
            border: "1px solid rgba(255,255,255,0.14)",
            boxShadow: "0 10px 34px -12px rgba(124,77,255,0.6)",
            backdropFilter: "blur(4px)",
          }}
        >
          {icon}
        </div>
      )}

      {title && (
        <Typography
          variant="h2"
          component="h2"
          style={{
            fontSize: "clamp(1.8rem, 3.2vw, 2.4rem)",
            fontWeight: 800,
            lineHeight: 1.12,
            letterSpacing: "-0.01em",
            marginBottom: "1rem",
            backgroundImage:
              "linear-gradient(95deg, #FFFFFF 0%, #FFC9D4 55%, #D9B8FF 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            WebkitTextFillColor: "transparent",
            color: "transparent",
          }}
        >
          {title}
        </Typography>
      )}

      {subtitle && (
        <Typography
          variant="subtitle1"
          style={{
            fontSize: "1.02rem",
            lineHeight: 1.7,
            color: "rgba(255,255,255,0.70)",
            maxWidth: 560,
            display: "inline-block",
          }}
        >
          {subtitle}
        </Typography>
      )}
    </>
  );
}

export default FeatureText;
